import { getCorrelationId } from 'src/lib/correlation'

type LogLevel = 'info' | 'warn' | 'error' | 'debug'

function write(level: LogLevel, msg: string, meta?: Record<string, unknown>) {
  const correlationId = getCorrelationId()
  const line = JSON.stringify({
    level,
    msg,
    timestamp: new Date().toISOString(),
    ...(correlationId && { correlationId }),
    ...meta
  })

  if (typeof process !== 'undefined' && process.stdout && process.stderr) {
    // Server-side: write to stdout/stderr
    const out = level === 'error' ? process.stderr : process.stdout
    out.write(line + '\n')
  } else {
    // Client-side: use console
    const consoleMethod = level === 'error' ? 'error' : level === 'warn' ? 'warn' : 'log'
    // eslint-disable-next-line no-console
    console[consoleMethod](line)
  }
}

export const logger = {
  info: (msg: string, meta?: Record<string, unknown>) => write('info', msg, meta),
  warn: (msg: string, meta?: Record<string, unknown>) => write('warn', msg, meta),
  error: (msg: string, meta?: Record<string, unknown>) => write('error', msg, meta),
  debug: (msg: string, meta?: Record<string, unknown>) => write('debug', msg, meta)
}
